<template>
  <div class="layout">
    <EButton
      v-once
      class="layout__skip-link"
      as="a"
      size="s"
      href="#main"
      tabindex="0"
      data-test-id="layout-skip-link"
    >
      {{ $t('common.skiplink.text') }}
    </EButton>
    <slot name="header" />
    <slot name="filters" />
    <main id="main" class="layout__content" tabindex="0" data-test-id="layout-main">
      <slot name="content" />
      <ECookieNotice />
    </main>
    <div class="layout__footer">
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
import { throttle } from 'throttle-debounce';
import keyboardMode from '~~/common/vue/mixins/keyboard-mode';
import ECookieNotice from '~~/common/vue/components/cookie-notice';
import EButton from '~~/common/vue/components/button';

const SCROLL_THROTTLE_TIME = 100;

export default {
  name: 'EStickyFooterLayout',
  components: {
    EButton,
    ECookieNotice,
  },
  mixins: [keyboardMode],
  data() {
    return {
      scrollState: {
        x: 0,
        y: 0,
        previousX: 0,
        previousY: 0,
        scrollingUp: false,
        scrollingDown: false,
        atTop: true,
      },
    };
  },
  created() {
    this.throttledOnScroll = throttle(SCROLL_THROTTLE_TIME, () => {
      this.scrollState.previousX = this.scrollState.x;
      this.scrollState.previousY = this.scrollState.y;
      this.scrollState.x = window?.scrollX || 0;
      this.scrollState.y = window?.scrollY || 0;
      this.scrollState.atTop = this.scrollState.y === 0;
      this.scrollState.scrollingUp = this.scrollState.y < this.scrollState.previousY;
      this.scrollState.scrollingDown = this.scrollState.y > this.scrollState.previousY;

      this.$emit('throttled-scroll', this.scrollState);
    });
  },
  beforeMount() {
    window.addEventListener('scroll', this.throttledOnScroll);
  },
};
</script>

<style lang="scss" scoped>
.layout {
  position: relative;
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  background-color: var(--color-background-secondary);
  color: var(--color-text-primary);

  @include desktop {
    background-color: var(--color-background-primary);
  }
}

.layout__content {
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  flex: 1;

  // some browsers will add an outline if the user
  // jumps onto the content element from the skip link
  &:focus {
    outline: none;
  }
}

.layout__footer {
  overflow: hidden;
}

.layout__skip-link {
  height: auto;
  left: $space-s;
  min-height: $space-1l;
  position: absolute;
  text-align: left;
  top: 75px;
  white-space: initial;
  width: $page-container-left-space-desktop - $space-m;
  z-index: $z-index-overlay;

  &:not(:focus) {
    @extend %sr-only;
  }
}
</style>
